import { ChevronLeft, ChevronRight, Radio } from "lucide-react";

const formatTimeAgo = (isoString, nowDate) => {
  if (!isoString) return "unknown";
  const seconds = Math.max(0, Math.round(((nowDate || new Date()).getTime() - new Date(isoString).getTime()) / 1000));
  if (seconds < 60) return `${seconds}s`;
  const minutes = Math.floor(seconds / 60);
  if (minutes < 60) return `${minutes}m ${seconds % 60}s`;
  return `${Math.floor(minutes / 60)}h ${minutes % 60}m`;
};

const ActivityRow = ({ event, now }) => (
  <div className="activity-row" data-testid={`activity-row-${event.code}`}>
    <span className="activity-code">{event.code}</span>
    <span className="activity-msg">{event.message.replace(new RegExp(`^${event.code}\\s*`), "")}</span>
    <span className="activity-time">{formatTimeAgo(event.timestamp, now)}</span>
  </div>
);

/**
 * Slide-out activity drawer anchored to the right edge.
 * A thin persistent tab hangs off the edge; clicking it slides the panel in.
 * Shows the last 10 X-coded events.
 */
export const ActivityPanel = ({ activities, now, open, onToggle }) => {
  const recent = (activities || []).slice(0, 10);
  return (
    <>
      <button
        className={`activity-drawer-tab ${open ? "open" : ""}`}
        onClick={onToggle}
        data-testid="activity-drawer-tab"
        title={open ? "Collapse activity" : "Show activity"}
      >
        <Radio size={12} />
        <span className="activity-drawer-tab-label">ACTIVITY</span>
        {open ? <ChevronRight size={12} /> : <ChevronLeft size={12} />}
      </button>

      <aside
        className={`activity-drawer ${open ? "open" : ""}`}
        data-testid="activity-panel"
        aria-hidden={!open}
      >
        <div className="activity-drawer-header">
          <span>ACTIVITY · LAST 10</span>
          <span className="activity-drawer-count">{recent.length}</span>
        </div>
        <div className="activity-drawer-body">
          {recent.length === 0 ? (
            <div className="empty-state">No activity yet…</div>
          ) : (
            recent.map((e, i) => (
              <ActivityRow key={`${e.timestamp}-${i}`} event={e} now={now} />
            ))
          )}
        </div>
      </aside>
    </>
  );
};
